<template>
  <div class="dhr-list">
    <h4 class="content-subtitle">Production</h4>
    <table v-if="data.length > 0" class="detail-table">
      <div class="detail-table-head">
        <span class="x-small">n°</span>
        <span class="large">Prod. Step</span>
        <span class="medium">Location</span>
        <span class="large">Equipment</span>
        <span class="big">Instruction</span>
      </div>
      <div class="detail-table-body">
        <div class="body-row"
          v-for="(step, index) in this.data" 
          :key="index"
        >
          <span class="x-small">{{ index+1 }}</span>
          <span class="large fixed-width">{{ step.name }}</span>
          <span class="medium">{{ step.location }}</span>
          <span class="large">{{ step.equipment }}</span>
          <span class="big">{{ step.instruction }}</span>
          <img v-if="data.length > 0 && step.isCompleted" class="checkicon" src="@/assets/images/succes.png" />
          <img v-else-if="doneData" class="checkicon" src="@/assets/images/error.png" />
        </div>
      </div>
    </table>
    <span v-else class="no-data">No production steps found.</span>
  </div>
</template>

<script>
export default {
  components: {},
   
  props: {
    data: Array,
    doneData: Array,
  },
  mounted() {
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {},
  watch: {
    data: {
      handler: function() {
        this.isLoaded = true
      },
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

.no-data {
  color: #6A6A6A;
  font-weight: 400;
  font-style: italic;
  padding-top: 16px;
}

.checkicon {
  height: 16px;
  padding-right: 16px;
}
</style>
